import styled from 'styled-components';

export const ProductName = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const ItemInfo = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: normal;
  word-break: break-all;
  overflow-wrap: break-word;
  flex-shrink: 0;
`;

export const ItemInfoLabel = styled.span`
  font-weight: 700;
`;

export const ProductNameItem = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;
